import React, { useEffect } from "react";
import useGoToPricing from "../../hooks/useGoToPricing";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Header from "../Homepage/sections/Header";
import Footer from "../Homepage/sections/Footer";
import { Page, HomepageGlobalStyles } from "../Homepage/styles";
import PostEditorPage from "./PostEditorPage";
import { PostEditorGlow, PostEditorShell } from "./PostEditor.styles";

/**
 * Lovable Add/Edit post shell + Homepage Header/Footer.
 * Publish/update/Wistia/crop APIs stay production (see PostEditorPage).
 */
const PostEditor = () => {
  const goToPricing = useGoToPricing();
  const loggedIn = isLoggedIn();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page>
      <HomepageGlobalStyles />
      <PostEditorShell>
        <PostEditorGlow aria-hidden="true" />
        <Header onSubscribeClick={goToPricing} hideSpacer />
        <PostEditorPage />
        <Footer onSubscribeClick={goToPricing} hideSubscribeCta={loggedIn} />
      </PostEditorShell>
    </Page>
  );
};

export default PostEditor;
